export default __webpack_public_path__ + "static/media/otis-alert-circle.7e1c9e75.svg";